<template>
  <form id="frm_action">
    <div class="p-formgrid row">
      <div class="col-lg-6">
        <div class="mt-3">
          <label class="txt-right required">Số lần kiểm tra / ngày</label>
          <div class="p-inputgroup">
            <InputText
              v-model="value"
              id="value"
              type="Number"
              class="text-box input-text-box"
              placeholder="Nhập"
              @input="allowOnlyNumbers('value')"
            />
            </div>
        </div>
      </div>

      <Toolbar class="fixed-bottom-toolbar col-lg-12">
        <template slot="right">
          <Button
            :label="$constants.TEXT_BUTTON.BACK"
            @click="backToList()"
            class="p-button-warning return-style-button" />
          <Button
            v-if="mode == 'edit'"
            :label="$constants.TEXT_BUTTON.EDIT"
            @click="saveData()"
            class="p-button-success main-style-button" />
          <Button
            v-else
            :label="$constants.TEXT_BUTTON.ADD"
            @click="saveData()"
            class="p-button-success main-style-button" />
        </template>
      </Toolbar>
    </div>
  </form>
</template>

<script>
export default {
  props: {
    mode: String,
    model: Object,
    users: Array,
  },
  data() {
    return {
      value: "",
    };
  },
  async mounted() {
    // console.log("this.model", this.model);
    if (this.model !== undefined && Object.keys(this.model).length > 0) {
      this.$commonFuction.is_loading(true);
      this.value = this.model.value;
      this.$commonFuction.is_loading(false);
    }
  },
  watch: {},
  methods: {
    backToList() {
      this.$emit("back");
    },

    allowOnlyNumbers(field) {
      // Only allow positive integers
      const value = this[field];
      const numericValue = value.replace(/[^0-9]/g, ''); // Remove any non-numeric characters

      // Ensure the value does not start with '0' unless it's the only character
      if (numericValue.length > 1 && numericValue.startsWith('0')) {
        this[field] = numericValue.substring(1);
      } else {
        this[field] = numericValue;
      }
    },

    async validateData() {
      this.validationErrors = {};

      let value_add = document.getElementById("value");
      if (
        this.value == undefined ||
        this.value == null ||
        this.value == ""
      ) {
        value_add.setCustomValidity("Số lần kiểm tra không được để trống!");
      } else {
        value_add.setCustomValidity("");
      }

      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()) {
        inpObj.reportValidity();
        return true;
      }
    },
    
    
    async saveData() {
      this.$commonFuction.is_loading(true);
      if (await this.validateData()) {
        this.$commonFuction.is_loading(false);
        return;
      }
      if (Object.entries(this.validationErrors).length !== 0) {
        this.$commonFuction.is_loading(false);
      }
      var params = {
        value : this.value,
      };
      // console.log("saveData", params);
      this.$emit("save", params);
      // }
    },
  },
};
</script>

<style lang="scss">
label {
  font-weight: bold;
}
.button-clear {
  position: absolute;
  background-color: red;
  border-radius: 50%;
  right: 0;
  top: 0;
  width: 20px;
  height: 20px;
  padding: 0;
  display: flex;
  cursor: pointer;
}
.item-img {
  width: 480px;
  height: 270px;
  position: relative;
  padding: 0;
}
.p-multiselect-panel .p-checkbox.p-component {
  display: none !important;
}
</style>
